import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import thunk from "redux-thunk";
import authSlice from "./authSlice";
import ProvinceSlice from "./ProvinceSlice";
import { composeWithDevTools } from "redux-devtools-extension";
import CitySlice from "./CitySlice";
import profileSlice from "./ProfileSlice";
import BankSlice from "./BankSlice";
import { loadingServiceSlice } from "./loadingServiceSlice";

const persistConfig = {
  key: "root",
  storage,
  blacklist: [],
};

const persistedReducer = persistReducer(
  persistConfig,
  combineReducers({
    auth: authSlice,
    profile: profileSlice,
    province: ProvinceSlice,
    bank: BankSlice,
    city: CitySlice,
    [loadingServiceSlice.name]: loadingServiceSlice.reducer,
  })
);

const store = configureStore({
  reducer: persistedReducer,
  middleware: [thunk],
  // devTools: process.env.NODE_ENV !== 'production', // Enable DevTools only in development
  // enhancers: composeWithDevTools(), // Add this line to enable Redux DevTools extension
});

const persistor = persistStore(store);
export { store, persistor };
